import React, {useEffect, useState} from 'react';
import {Grid2 as Grid, Paper, TableContainer, Table, TableHead, TableRow, TableCell, Typography, TableBody, Link, useTheme, useMediaQuery} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { LiabilityItem } from '../../../types/reports/liabilityItem';

interface Props {
   items?:LiabilityItem[];
}

interface LiabilityGroup {
    groupName: string;
    items: LiabilityItem[];
}


const LiabilitiesScheduleTable = (props: Props): JSX.Element => {

 const theme = useTheme();
 const isSM = useMediaQuery(theme.breakpoints.down('sm'));
 const [groupData, setGroupData] = useState<LiabilityGroup[]>();

 useEffect(() => {
    if(props.items){
        let items = props.items;
        let groups: LiabilityGroup[] = [];
        items.forEach((item: LiabilityItem) => {
          let groupName = item.fullNameReverse;
          let groupIndex = groups.findIndex((group) => group.groupName === groupName);
          if (groupIndex> -1){
              groups[groupIndex].items.push(item);
          }else{
              groups.push({
              groupName: item.fullNameReverse,
              items: [item]
            });
          }
        })
        setGroupData(groups);
    }
 }, [props.items])

    return (
        <Grid container spacing={1}>
         <TableContainer component={Paper} sx={{ maxHeight: 800 }}>
             <Table stickyHeader aria-label="liabilities schedule table" size="small">
                 <TableHead>
                     <TableRow>
                         <TableCell>
                             <Typography variant={'subtitle2'} fontWeight={600}>
                                Date
                             </Typography>
                         </TableCell>
                         <TableCell>
                             <Typography variant={'subtitle2'} fontWeight={600}>
                                Name/Address
                             </Typography>
                         </TableCell>
                         {
                            isSM &&
                            <TableCell>
                                <Typography variant={'subtitle2'} fontWeight={600}>
                                Amount	
                                </Typography>
                            </TableCell>
                         }
                         <TableCell>
                             <Typography variant={'subtitle2'} fontWeight={600}>
                                Type
                             </Typography>
                         </TableCell>
                         <TableCell>
                             <Typography variant={'subtitle2'} fontWeight={600}>
                                Description
                             </Typography>
                         </TableCell>
                         {
                            !isSM &&
                            <TableCell>
                                <Typography variant={'subtitle2'} fontWeight={600}>
                                Amount	
                                </Typography>
                            </TableCell>
                         }

                     </TableRow>
                 </TableHead>
                 <TableBody>
                     {groupData?.map((group: LiabilityGroup, i) => (
                         <>
                            <TableRow key={i} sx={{ bgcolor: 'alternate.dark' }}>
                                <TableCell colSpan={8}>
                                    <Typography variant={'subtitle2'} fontWeight={650}>{group.groupName}</Typography>
                                </TableCell>
                            </TableRow>
                            {
                                group.items.map((item: LiabilityItem, j) => (
                                    <TableRow
                                    key={j}
                                    sx={{
                                        '&:last-child td, &:last-child th': { border: 0 },
                                    }}
                                    >
                                        <TableCell>
                                            <Typography variant={'subtitle2'}>
                                                {item.date}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant={'subtitle2'}>
                                                {item.fullNameReverse}
                                            </Typography>
                                            <Typography variant={'subtitle2'} component={'i'}>
                                                {item.fullAddress}
                                            </Typography>
                                        </TableCell>
                                        {
                                            isSM &&
                                            <TableCell>
                                                <Typography variant={'subtitle2'} component={'i'}>
                                                    {item.liabilityEffectAmountDisplay}
                                                </Typography>
                                            </TableCell>
                                        }
                                        <TableCell>
                                            <Typography variant={'subtitle2'}>
                                                {item.recordTypeDescription}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant={'subtitle2'}>
                                                {item.description}
                                            </Typography>
                                        </TableCell>
                                        {
                                            !isSM &&
                                            <TableCell>
                                                <Typography variant={'subtitle2'} component={'i'}>
                                                    {item.liabilityEffectAmountDisplay}
                                                </Typography>
                                            </TableCell>
                                        }
                                    </TableRow>
                                ))
                            }
                         </>  
                    ))}
                 </TableBody>
             </Table>
         </TableContainer>
        </Grid>
    );
}

export default LiabilitiesScheduleTable;